import { ref } from 'vue';

export function useGroupManagement() {
  // 모달 상태 관리
  const modals = ref({
    create: false,
    edit: false,
  });

  // 선택된 그룹
  const selectedGroup = ref(null);

  // 로딩 상태
  const isCreating = ref(false);
  const isUpdating = ref(false);
  const isDeleting = ref(false);

  // 모달 열기
  const openModal = (modalName, group = null) => {
    modals.value[modalName] = true;
    if (group) {
      selectedGroup.value = group;
    }
  };

  // 모달 닫기
  const closeModal = (modalName) => {
    modals.value[modalName] = false;
    if (modalName === 'edit') {
      selectedGroup.value = null;
    }
  };

  return {
    modals,
    selectedGroup,
    isCreating,
    isUpdating,
    isDeleting,
    openModal,
    closeModal,
  };
} 